import { Transform } from 'class-transformer';

export function TransformDate({ toClassOnly = false } = {}) {
	return Transform(({ value }) => (value ? new Date(value) : value), {
		toClassOnly,
	});
}
